import wrapper from '../analytics-wrapper';

export default {
  trackPageView({ name }) {
    wrapper.track('Viewed page', { 'Route Name': name });
  },
};
